import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ServiceChartModel } from 'src/app/models/charts/rental/service-chart.model';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { ServicePrintModel } from 'src/app/models/rental/service-print-model';
import { ServiceModel } from 'src/app/models/rental/service.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InvoiceServiceTableModel } from 'src/app/models/tables/rental/invoice-service-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServiceService {

  constructor(private _httpClient: HttpClient) { }

  annulService(serviceId: number): Observable<ServiceModel> {
    return this._httpClient.put<ServiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.AnnulService}/${serviceId}`, null);
  }

  attachFilesToService(serviceId: number, files: FormData): Observable<Array<string>> {
    return this._httpClient.post<Array<string>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.AttachFilesToService}/${serviceId}`, files);
  }

  blockService(serviceId: number): Observable<ServiceModel> {
    return this._httpClient.put<ServiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.BlockService}/${serviceId}`, null)
  }

  createService(serviceModel: ServiceModel): Observable<ServiceModel> {
    return this._httpClient.post<ServiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.CreateService}`, serviceModel);
  }

  saveServiceByOrder(orderDetailId: number, serviceId: number): Observable<ServiceModel> {
    const params = new HttpParams().set('orderDetailId', orderDetailId).set('serviceId', serviceId);
    return this._httpClient.post<ServiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.SaveServiceByOrderAsync}`,
      null, { params: params }
    );
  }

  deleteFilesToService(serviceId: number, file: string): Observable<Array<string>> {
    const itemFilterResponse = new ItemFilterModel("file", null, serviceId, file);
    return this._httpClient.post<Array<string>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.DeleteFilesToService}`, itemFilterResponse);
  }

  deleteService(serviceId: number): Observable<ServiceModel> {
    return this._httpClient.delete<ServiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.DeleteService}/${serviceId}`);
  }

  downloadFileToService(serviceId: number, file: string): Observable<HttpEvent<Blob>> {
    const itemFilterResponse = new ItemFilterModel("file", null, serviceId, file);
    return this._httpClient.request(new HttpRequest('POST', `${environment.apiCervinoBackend}${enpointCervinoWeb.service.DownloadFileToService}`,
      itemFilterResponse, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  exportInvoiceForServiceConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.ExportInvoiceForServiceConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getFilesToService(serviceId: number): Observable<any[]> {
    return this._httpClient.get<any[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetFilesToServiceAsync}/${serviceId}`
    );
  }

  getAllBranchesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetAllBranchesForSelectAsync}`,);
  }

  getAllClientsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetAllClientsForSelectAsync}`,);
  }

  getAllCostCentersForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetAllCostCentersForSelectAsync}`,);
  }

  getAllCostCenterByBranchForSelect(branchId: number): Observable<Array<any>> {
    const params = new HttpParams().set('branchId', branchId)
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetAllCostCenterByBranchIdForSelectAsync}`,
      { params: params }
    );
  }

  getAllInvoiceForServicesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<InvoiceServiceTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<InvoiceServiceTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetAllInvoiceForServicesWithPagination}`,
      filters, { params: params }
    );
  }

  getAllServicesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetAllServicesWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetColumnsForGeneralConsultationAsync}`);
  }

  getColumnsForInvoiceConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetColumnsForInvoiceConsultationAsync}`);
  }

  getCostCenterByIdAsync(costCenterId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetCostCenterByIdAsync}/${costCenterId}`);
  }

  getEmptyServicePrint(): Observable<ServicePrintModel> {
    return this._httpClient.get<ServicePrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetEmptyServicePrint}`);
  }

  getFirstServiceByKeysAsync(branchId: number): Observable<ServiceModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<ServiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetFirstServiceByKeys}`, { params: params });
  }

  getIndicatorsForGeneralConsultation(filters: ColumnResponseModel[]): Observable<ServiceChartModel> {
    return this._httpClient.post<ServiceChartModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetIndicatorsForGeneralConsultationAsync}`,
      filters
    );
  }

  getLastServiceByKeysAsync(branchId: number): Observable<ServiceModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<ServiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetLastServiceByKeys}`, { params: params });
  }

  getNextServiceByKeysAsync(branchId: number, consecutive: number): Observable<ServiceModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<ServiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetNextServiceByKeys}`, { params: params });
  }

  getPermissionPrint(): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetPermissionPrint}`);
  }

  getPreviusServiceByKeysAsync(branchId: number, consecutive: number): Observable<ServiceModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<ServiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetPreviusServiceByKeys}`, { params: params });
  }

  getServiceById(serviceId: number): Observable<ServiceModel> {
    return this._httpClient.get<ServiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetServiceById}/${serviceId}`);
  }

  getServiceByKeysAsync(branchId: number, consecutive: number): Observable<ServiceModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<ServiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetServiceByKeys}`, { params: params });
  }

  getServiceByKeysByPrintAsync(branchId: number, consecutive: number, serviceId: number): Observable<ServicePrintModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive).set('serviceId', serviceId);
    return this._httpClient.get<ServicePrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.GetServiceByKeysByPrintAsync}`,
      { params }
    );
  }

  printService(serviceId: number): Observable<ServiceModel> {
    return this._httpClient.put<ServiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.PrintService}/${serviceId}`, null)
  }

  setStateService(serviceId: number): Observable<ServiceModel> {
    return this._httpClient.put<ServiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.SetStateService}/${serviceId}`, null);
  }

  updateService(serviceContract: ServiceModel): Observable<ServiceModel> {
    return this._httpClient.put<ServiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.service.UpdateService}`, serviceContract);
  }
}
